
import { RootTest } from 'dialer'

export class DriveTestSeqStatus {
    static readonly SEQ_FINISHED = 'SEQ_FINISHED' // drive test point seq run without dialer
    static readonly DIALER_SEQ_FINISHED = 'DIALER_SEQ_FINISHED'
}

export class DriveTestSeq {

    seqid: string = ''
    testPointId: string = ''
    userId: string = ''
    stage: string = ''
    routeId: string = ''
    cycle: number = 0
    testOrder: number = 0
    startTime: string = null
    endTime: string = null
    dialer: RootTest = null
    importTime: string = null
    status: string = null

    updatedAt?: number = 0
    _rev?: string = ''
    groupingfield?: string = ''
}